import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { tomos, tomoIncludes } from '../data/salesData';
export function TomosSection() {
  return <section className="border-b border-[var(--line)] bg-[var(--bg)] py-16 sm:py-20" data-id="element-229" data-mp="1p320p9xzwyly">
      <div className="mx-auto max-w-6xl px-4" data-id="element-230" data-mp="1u2dk6qpqyi78">
        <SectionHeading eyebrow="🏆 6 Tomos + 6 Bonos + Sistema de Escalamiento" data-id="element-231" data-mp="1u1bzduixihcb">
          Pilates Clinic
        </SectionHeading>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[var(--text-soft)]" data-id="element-232" data-mp="xeqr92rvthyj">
          Todo lo que necesitás para trabajar seguro, profesional y rentable con
          alumnos limitados.
        </p>

        <h3 className="mt-12 text-center text-sm font-semibold uppercase tracking-[0.25em] text-[var(--slate)]" data-id="element-233" data-mp="16ff3brxpt88s">
          Los 6 Tomos
        </h3>

        <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-234" data-mp="2hr6b28rihzuz">
          {tomos.map(tomo => <article key={tomo.title} className="rounded-2xl border border-[var(--line)] bg-[var(--surface)] p-6 transition-colors duration-200 ease-out hover:border-[var(--rose)]/50" data-id="element-235" data-mp="2mq13m2fa72sa">
              <span className="text-3xl" aria-hidden="true" data-id="element-236" data-mp="2mkiw4wfujeyo">
                {tomo.emoji}
              </span>
              <h4 className="mt-4 font-serif-display text-xl font-bold text-[var(--text)]" data-id="element-237" data-mp="2hpdbe0y6k6c6">
                {tomo.title}
              </h4>
              <p className="mt-2 text-sm text-[var(--text-soft)]" data-id="element-238" data-mp="27pmmcese2jjh">
                {tomo.description}
              </p>
            </article>)}
        </div>

        <div className="mt-12 rounded-2xl border border-[var(--rose)]/30 bg-[var(--rose-tint)] p-6 sm:p-8" data-id="element-239" data-mp="1yx2huxpf1kqq">
          <h3 className="font-serif-display text-2xl font-bold text-[var(--text)]" data-id="element-240" data-mp="1ty7ztxz9w07o">
            Cada tomo incluye:
          </h3>
          <ul className="mt-6 grid gap-3 sm:grid-cols-3" data-id="element-241" data-mp="1oxtski5hwuap">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-242" data-mp="1k13bbrhyfsnp">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[var(--rose)]/20" data-id="element-243" data-mp="1acfy0jgfdux0">
                  <CheckIcon className="h-4 w-4 text-[var(--rose)]" aria-hidden="true" data-id="element-244" data-mp="1fcaju8lcfub7" />
                </span>
                <span className="text-[var(--text)]/90" data-id="element-245" data-mp="11ct1oc2jzfat">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}